export default "__VITE_ASSET__Do3Qw4bq__"